import { useSelector } from "react-redux";
import { useGetDealsDetailsQuery } from "../../../redux/api/DealsPdf";
import { selectCurrentagency } from "../../../redux/features/authSlice";
import { Box, Button, styled, Typography, Stack } from "@mui/material";
import { DEAL_COLUMN } from "./dealsData";
import MaterialReactTable from "material-react-table";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import BackButton from "../../../components/BackButton/BackButton";

export const DealsPdf = () => {
  const currentAgency = useSelector(selectCurrentagency);
  const { data, isLoading, refetch } = useGetDealsDetailsQuery(
    currentAgency.agencyid
  );

  const navigate = useNavigate();

  const agencyEarning =
    data?.agencyDealCountsAndEarnings[0]?.TotalAgencyEarning?.toFixed(2);
  const agencyDeals = data?.agencyDealCountsAndEarnings[0]?.DealCount;

  return (
    <>
          <BackButton sx={{ mb: 2 }} /> 


      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={2}
        sx={{
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "center" },
        }}
      >
        <Typography variant="h2" sx={{ mb: { xs: 2, sm: 0 } }}>
          All Deals Report
        </Typography>
        <Box display="flex" gap={2}>
          <StyledButton variant="contained" sx={{ color: "white" }}>
            Total Earning {agencyEarning}
          </StyledButton>
          <StyledButton variant="contained" sx={{ color: "white" }}>
            Total Deals {agencyDeals}
          </StyledButton>
        </Box>
      </Box>

      <MaterialReactTable
        state={{ showSkeletons: isLoading }}
        columns={DEAL_COLUMN}
        data={data?.dealInfo ?? []}
        refetch={refetch}
        initialState={{ density: "compact", pagination: { pageSize: 20 } }}
        enableDensityToggle={false}
      />
    </>
  );
};

const StyledButton = styled(Button)(({ theme }) => ({
  marginRight: "8px",
}));
